import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import Pagination from "react-js-pagination";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

import { GET_COUPONLIST } from '../../actions';

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      couponlist:'',
      editable: false,
      priorityid:'',
      priorityvalue:'',
      activePage: 1,
      totalRecord: '',
      search_all:''
    };

     var admin_id = localStorage.getItem("admin_id");
      var qs = require('qs');
      var postobject = {
        activePage: 1,
        search_all: '',
        admin_id: admin_id
      };

    this.props.getCouponList(qs.stringify(postobject));

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
   componentDidMount() {
      document.title = PageTitle('Coupon');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }

   handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
    this.props.getCouponList(qs.stringify(postobject))
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
          const formPayload = this.state;
          var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
              activePage : 1,
              search_all : formPayload.search_all,
              admin_id  : admin_id         
          };
          //console.log(postObject);
          this.props.getCouponList(qs.stringify(postObject));
        
    }

   componentWillReceiveProps(Props){

    if (Object.keys(Props.couponlist).length > 0) {
      if (Props.couponlist[0]["status"] === "success") {
       /* this.setState({
          couponlist: Props.couponlist[0]["couponlist"],
        });*/
         this.setState({ totalRecord : Props.couponlist[0].records_count, couponlist: Props.couponlist[0]["couponlist"] }, function() {
            this.couponlist();
          });
      }
    }
 

   }


  couponlist() {
    var couponlist = this.props.couponlist[0];
    if (couponlist != "undefined" && couponlist != null) {
      if (couponlist.status == "success") {
        if (Object.keys(couponlist).length > 0) {
          const couponlistDetails = couponlist.couponlist.map(
            (couponlist, Index) => {
              let sno = Index+1;
              if(couponlist.coupon_status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
              return (
                <tr key={couponlist.coupon_id}>
                <td>{sno}</td>
                  <td>{couponlist.code}</td>
                  <td>{couponlist.discount}</td>
                  <td>{couponlist.valid_from}</td>
                  <td>{couponlist.valid_to}</td>
                  <td>{couponlist.total_usage}</td>
                  <td>{couponlist.created_on}</td>
                  <td>{status}</td>
                  <td> <Link to={{ pathname: '/coupon-edit/'+couponlist.coupon_id}} className="" title="Edit">  <i className="fa fa-edit" aria-hidden="true"></i></Link></td>
                </tr>
              );
            }
          );
          return couponlistDetails ;
        }
      } else {
        return (
          <tr>
            <td colspan="6" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }
  
  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="coupons" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Coupons</h3>
                </div>

                 <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
              <div className="add_button">  
                    <a className="add" href='/coupon-add'>Add</a> 
                </div>
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Coupon Code</th>
					  <th>Discount Amount</th>
					  <th>Valid From</th>
					  <th>Valid Till</th>
					  <th>Total Usage</th>
					  <th>Created On</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.couponlist()}</tbody>
                </Table>
                 <div className="text-center">
            <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={10}
            totalItemsCount={this.state.totalRecord}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />
          </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    couponlist: state.couponlist    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCouponList: (formVal) =>{
       dispatch({ type: GET_COUPONLIST , formVal});
    }    
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));